import React, { Fragment } from 'react';
import { numberFormat } from '../../constants/numberFormat';

export const QuoteResponse = ({
  quoteResponse,
  quoteLoading,
  currentStep,
}) => {
  if (!quoteResponse) return null;

  const {
    quote: {
      result: {
        nights,
        rate,
        rental_amount: rentalAmount,
        per_night: { amount: ratePerNight },
        fees: {
          items: feeItems,
          optional_items: optionalFeeItems
        },
        taxes: {
          items: taxItems
        },
      },
    },
  } = quoteResponse;

  return (
    <div className={`fees-container ${currentStep !== 2 ? 'mobile-hidden' : ''}`}>
      <p>${ratePerNight}</p>
      <span>per night (x{nights})</span>
      {feeItems && feeItems.length > 0 && feeItems.map(({ label, amount }, ind) => (
        <Fragment key={ind}>
          <p>${amount}</p>
          <span>{label}</span>
        </Fragment>
      ))}
      {optionalFeeItems && optionalFeeItems.length > 0 && (
        <Fragment>
          <p className="optional-fees-title">Other possible Fees</p>
          {optionalFeeItems.map(({ label, amount }, ind) => (
            <Fragment key={ind}>
              <p>${amount}</p>
              <span>{label}</span>
            </Fragment>
          ))}
        </Fragment>
      )}
      {taxItems && taxItems.length > 0 && (
        <Fragment>
          <p className="optional-fees-title">Taxes</p>
          {taxItems.map(({ label, amount }, ind) => (
            <Fragment key={ind}>
              <p>${amount}</p>
              <span>{label}</span>
            </Fragment>
          ))}
        </Fragment>
      )}
    </div>

    // <div className="fees-container">
    //   {!quoteLoading && (
    //     <div className="line-item">
    //       <p className="line-item--title">
    //         Rate ({numberFormat(ratePerNight)} x {nights} nights)
    //       </p>
    //       <p className="line-item--value">{numberFormat(rate)}</p>
    //     </div>
    //   )}
    //   {fees?.items &&
    //     !quoteLoading &&
    //     fees.items.map((fee, i) => (
    //       <Fragment key={i}>
    //         <div className="line-item">
    //           <p className="line-item--title">{fee.label}</p>
    //           <p className="line-item--value">{numberFormat(fee.amount)}</p>
    //         </div>
    //       </Fragment>
    //     ))}
    //   {taxes?.subtotal > -1 && !quoteLoading && (
    //     <div className="line-item">
    //       <p className="line-item--title">Taxes</p>
    //       <p className="line-item--value">{numberFormat(taxes.subtotal)}</p>
    //     </div>
    //   )}
    //   {quoteResponse && !quoteLoading && (
    //     <div className="line-item line-item--last">
    //       <p className="line-item--total-title">Total</p>
    //       <p className="line-item--total-value">{numberFormat(rentalAmount)}</p>
    //     </div>
    //   )}
    // </div>
  );
};
